import React from 'react';
import { getShareConfig } from '../utils';
import { isAppModule } from '@src/utils/constants';
import { realTimeModeOnTrendsSelector } from '@src/store/common/selectors';
import { modeSelector } from '@src/store/trends/selectors';
import { useSelector } from 'react-redux';
import { prefixedCheckFeature } from '@src/utils/platform/features/checkFeature';
import { Space } from 'antd';
import ExportOption from './ExportOption';
import LatchShare from './LatchShare';
import PopShare from '@src/components/share/PopShare';
const { baseUrl } = window.conviva;

const cf = prefixedCheckFeature('trends.actions');

function External() {
  const liveMode = useSelector(realTimeModeOnTrendsSelector);
  const { mode } = useSelector(modeSelector);

  const showShareOption = isAppModule ? !liveMode : cf('share', true);
  const shareConfig = getShareConfig(baseUrl, isAppModule, mode);

  return (
    <>
      <LatchShare />
      <Space>
        {showShareOption && <PopShare config={shareConfig} />}
        <ExportOption />
      </Space>
    </>
  );
}

export default External;
